import { memo, useMemo, useState } from "react";
import useValidate from "../../store/hooks/useValidator";
import { useDispatch, useSelector } from "react-redux";
import { callApiAction } from "../../store/actions/commonAction";
import { closeModal } from "../../store/actions/modalAction";
import { useParams } from "react-router-dom";
import { SNACK_BAR_VARIETNS } from "../../utils/constants/main";
import { callSnackBar } from "../../store/actions/snackbarAction";
import CreateVersionUi from "./CreateVersionUi";
import { createVersion } from "../../apis/version.api";

const CreateVersionController = ({ callBack = () => { }, id, role = null }) => {
    const validate = useValidate();
    const { settings } = useSelector((state) => state)
    const dispatch = useDispatch();
    const params = useParams();
    const modalKey = 'version';
    const title = "Version"; // Change this to "Product" if needed
    const [loading, setLoading] = useState(false);
    const isRolePredefined = role !== null;
    const [fields, setFields] = useState({
        name: "",
        main_version: null,
        sub_version: null,
        app_type: "",
        description: "",
        err: ""
    });

    const validationSchemaForCreate = useMemo(
        () =>
            [
                {
                    required: true,
                    value: fields.name,
                    field: 'Version Name '
                },
                {
                    required: true,
                    value: fields.description,
                    field: 'Version Description',
                },
                {
                    required: true,
                    value: fields.main_version,
                    field: 'Main Version',
                },
                {
                    required: true,
                    value: fields.sub_version,
                    field: 'Sub Version',
                }
            ],
        [fields]
    );


    const createFunction = async () => {
        const validationResponse = validate(validationSchemaForCreate);

        if (validationResponse === true) {
            setLoading(true);
            dispatch(
                callApiAction(
                    async () => await createVersion({ ...fields }),
                    async (response) => {
                        callBack()
                        setLoading(false);
                        dispatch(callSnackBar("Version Created Successfully", SNACK_BAR_VARIETNS.suceess))
                        dispatch(closeModal(modalKey));
                    },
                    (err) => {
                        setLoading(false);
                        setFields({ ...fields, err });
                    }
                )
            );
        } else {
            setFields({ ...fields, err: validationResponse });
        }
    };


    const onSubmit = async (e) => {
        e.preventDefault();
        createFunction();
    };

    return (
        <CreateVersionUi
            isRolePredefined={isRolePredefined}
            modalKey={modalKey}
            title={title}
            isUpdate={id}
            loading={loading}
            fields={fields}
            onSubmit={onSubmit}
            setFields={setFields}
        />
    );
};
export default memo(CreateVersionController);
